/* istanbul ignore file */
export const getFallbackBodyStyles = () => ({
  link: {
    fontSize: '16px !important',
    fontFamily: 'Segoe UI !important',
    fontWeight: '400 !important',
    lineHeight: '19px !important',
    color: '#0078D4 !important',
    padding: '5px !important',
    height: 'auto !important',
    whiteSpace: 'normal !important',
    textAlign: 'left !important',
    minWidth: '232px !important',
  },
  message: {
    fontFamily: 'Segoe UI',
    minWidth: '232px',
    fontSize: '12px',
    lineHeight: '22px',
    paddingBottom: '10px',
  },
});
